import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: 657,
      maxWidth: 'unset',
    },
    description: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(22),
    },
    radioCardsWrapper: {
      margin: theme.spacing(2, 0),
      display: 'flex',
      flexDirection: 'column',
    },
    radioGroup: {
      gap: theme.spacing(1),
      maxHeight: 220,
      overflowY: 'auto',
      flexWrap: 'nowrap !important',
    },
    selected: {},
    radioItem: {
      borderRadius: 8,
      padding: theme.spacing(0.75, 1.25),
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
      border: `1px solid ${COLORS.gray.gray70}`,
      '&$selected': {
        borderColor: COLORS.primary.active,
      },
      '&:hover': {
        backgroundColor: COLORS.gray.gray90,
      },
    },

    dialogActions: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    actionsWrapper: {
      display: 'flex',
      gap: theme.spacing(1),
    },
    applyAllLabel: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
      display: 'none',
    },
    checkbox: {
      '& svg': {
        fontSize: theme.typography.pxToRem(16),
      },
    },
    underline: { textDecoration: 'underline' },
    actionButton: {},
    banner: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      backgroundColor: COLORS.primary.light,
      padding: theme.spacing(1.5, 2),
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
      color: COLORS.primary.active,
      marginTop: theme.spacing(2),
      borderRadius: 8,
    },
    iconInformation: {
      '& svg': {
        color: COLORS.primary.active,
      },
    },
  }),
  { name: 'ProjectBrandVoicesSelectionPopup' }
);
